import React from 'react';
import Api from './Api'
import Config from '../../../../Config';
import Cookie from './Cookie';
import { matchPath } from 'react-router';
import Button from "../../../views/components/CustomButtons/Button";

const $ = function(selector){
    return document.querySelectorAll(selector);
}
export default $;

const html = document.body.parentElement;
const hasOpacity = (html.style.opacity != null);
// const hasFilter = (html.style.filter != null);
const reAlpha = /alpha\(opacity=([\d.]+)\)/i;
var floatName = (html.style.cssFloat == null) ? 'styleFloat' : 'cssFloat';

const helper = {
    isMobile: null,
    serialize(obj){
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    },
    getParam(name) {
        return decodeURI(
            (RegExp(name+"=(.+?)(&|$)").exec(window.location.search)||['',null])[1]
        );
    },
    getSubDomainType(){
        var host = document.location.hostname;
        var domain = host.replace("www.","");
        var subDomain = domain.split(".")[0];
        var subDomainPart = subDomain.split("-");
        if(subDomainPart.length >= 1){
            return subDomainPart[0];
        }
        return null;
    },
    getSubDomain(){
        var host = document.location.hostname;
        var domain = host.replace("www.","");
        var subDomain = domain.split(".")[0];
        var subDomainPart = subDomain.split("-");
        if(subDomainPart.length === 2){
            return subDomainPart[1];
        }
        return subDomainPart[0];
    },
    getSubDomainUrl(){
        var path = document.location.pathname;
        var pathSplit = [];
        if(path.charAt(0) === "/"){
          pathSplit = path.slice(1).split("/");
        }else{
          pathSplit = path.split("/");
        }
        var domainUrl = pathSplit[0];
        const domains = Api.getDomains();
        if(domains.includes(domainUrl)){
          return domainUrl;
        }
        return "-";
    },
    formatViewCount: function(viewCount){
        if (viewCount >= 1000 && viewCount < 1000000){
            viewCount = (viewCount/1000).round(1)+"K";
        }
        if (viewCount >= 1000000){
            viewCount = (viewCount/1000000).round(1)+"M";
        }
        return viewCount;
    },
    getBaseUrl(basePath){
        let apiUrl = Config.getPGApiUrl();
        if(basePath){
          return apiUrl.split(".com")[0]+".com";
        }
        apiUrl = apiUrl.split("/api")[0];
        return apiUrl;
    },
    openIframeLink: function(element){
        const href = element.getAttribute("data-href");
        if(!href || href.length <= 0){
            element = element.parentElement;
        }
        this.logShareAction(element);
        window.open(element.getAttribute("data-href"), 'share',
        'status=0,' +
        'toolbar=0,' +
        'location=0,' +
        'menubar=0,' +
        'directories=0,' +
        'scrollbars=0,' +
        'resizable=0,' +
        'height=500,' +
        'width=600');
    },
    logShareAction: function(element){
        try{
            var requestData = {};
            requestData.contentType = element.getAttribute("data-type");
            requestData.contentID = element.getAttribute("data-id");
            requestData.network = element.getAttribute("data-network");
            Api.logShareAction(requestData);            
        }catch(e){  }
    },
    objectToUrl(object){
        const keys = Object.keys(object);
        let url = "";
        for (const key of keys) {
            url += "/"+key+"/"+object[key];
        }
        return url;
    },
    getCampaignParams(loggedIn){
        let params = [];
        if(loggedIn){
            params['gg'] = Cookie.read("user_content_id");
            params['utm_content'] = "gg="+params['gg'];
        }else if(Cookie.read("__utmc")){
            params['__utmc'] = Cookie.read("__utmc");
            params['utm_content'] = "__utmc="+params['__utmc'];
        }
        params['utm_medium'] = 'share';
        return params;
    },
    prepareShareUrl(params,href){
        href = href.substring(0,href.indexOf("?")); //Remove query string;
        href = href.replace(/\/$/, "");
        href = href+this.objectToUrl(params);
        return href;
    },
    getFbShareUrl(loggedIn,href){
        const params = this.getCampaignParams(loggedIn);
        params['utm_source'] = 'facebook';
        return this.prepareShareUrl(params,href);
    },
    getPintShareUrl(loggedIn,href){
        const params = this.getCampaignParams(loggedIn);
        params['utm_source'] = 'pinterest';
        return this.prepareShareUrl(params,href);
    },
    getEmailShareUrl(loggedIn,href){
        const params = this.getCampaignParams(loggedIn);
        params['utm_source'] = 'email';
        return this.prepareShareUrl(params,href);
    },
    camelCase: function(string){
		return string.replace(/-\D/g, function(match){
			return match.charAt(1).toUpperCase();
		});
    },
    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    setOpacity(element, opacity){
        if(hasOpacity){
            element.style.opacity = opacity;
            return;
        }
        var style = element.style;
        if (!element.currentStyle || !element.currentStyle.hasLayout) style.zoom = 1;
        if (opacity === null || opacity === 1) opacity = '';
        else opacity = 'alpha(opacity=' + (opacity * 100).limit(0, 100).round() + ')';
        var filter = style.filter || '';
        style.filter = reAlpha.test(filter) ? filter.replace(reAlpha, opacity) : filter + opacity;
        if (!style.filter) style.removeAttribute('filter');
    },
    setStyle: function(element,property, value){
		if (property === 'opacity'){
			if (value !== null) value = parseFloat(value);
			this.setOpacity(element, value);
			return this;
		}
		property = this.camelCase((property === 'float' ? floatName : property));
		if (value === String(Number(value))){
			value = Math.round(value);
		}
		element.style[property] = value;
		//<ltIE9>
		if ((value === '' || value === null) && element.style.removeAttribute){
			element.style.removeAttribute(property);
        }
		//</ltIE9>
		return this;
    },
    setStyles: function(element,styles){
		for (var style in styles) this.setStyle(element, style, styles[style]);
		return this;
    },
    fallbackCopyTextToClipboard(text) {
        if (this.isIOS() === false) {
            document.body.parentElement.style.overflow = "hidden";
            let el = document.createElement("div");
            el.contentEditable = true;
            el.readOnly = true;
            el.innerHTML = text;
            const isRTL = false;

            // Prevent zooming on iOS
            el.style.fontSize = '12pt';
            // Reset box model
            el.style.border = '0';
            el.style.padding = '0';
            el.style.margin = '0';
            // Move element out of screen horizontally
            el.style.position = 'absolute';
            el.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            el.style.top = yPosition + 'px';
            document.body.appendChild(el);
            try{
                // create a selectable range
                var range = document.createRange();
                range.selectNodeContents(el);

                // select the range
                var selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                //el.setSelectionRange(0, 999999);
                const status = document.execCommand('copy');
                document.body.removeChild(el);
                console.log('Async: Copying to clipboard was successful! with status = '+status);
            }catch(err){
                document.body.removeChild(el);
                console.error('Fallback: Oops, unable to copy', err);
            }
            document.body.parentElement.style.overflow = "";
            return;
        }
        
        this.fallbackCopyTextToClipboardiOS(text);
    },
    fallbackCopyTextToClipboardiOS(text) {
        document.body.parentElement.style.overflow = "hidden";
        let el = document.createElement("textarea");
        el.setAttribute('readonly', '');
        el.value = text;
        el.select();
        el.setSelectionRange(0, el.value.length);
        const isRTL = false;

        // Prevent zooming on iOS
        el.style.fontSize = '12pt';
        // Reset box model
        el.style.border = '0';
        el.style.padding = '0';
        el.style.margin = '0';
        // Move element out of screen horizontally
        el.style.position = 'absolute';
        el.style[isRTL ? 'right' : 'left'] = '-9999px';
        // Move element to the same position vertically
        var yPosition = window.pageYOffset || document.documentElement.scrollTop;
        el.style.top = yPosition + 'px';
        document.body.appendChild(el);
        try{
            const status = document.execCommand('copy');
            document.body.removeChild(el);
            console.log('Async: Copying to clipboard was successful! with status = '+status);
        }catch(err){
            document.body.removeChild(el);
            console.error('Fallback: Oops, unable to copy', err);
        }
        document.body.parentElement.style.overflow = "";
    },
    copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            this.fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function() {
            console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
    },
    prepareSocialUrl(socialDomain, username){
        let socialUrl = "https://"+socialDomain+".com/"+username;
        if(socialDomain === "linkedin"){
            socialUrl = "https://"+socialDomain+".com/in/"+username;
        }
        return socialUrl;
    },
    isURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return pattern.test(str);
    },
    prepareExternalUrl(url){
        try{
            new URL(url); //Check if valid url
        }catch(e){ //Fallback
            if(url.length > 0 && url.indexOf("http://") === -1 && url.indexOf("https://") === -1){
                url = "http://"+url;
            }
        }
        return url;
    },
    isTransparentHeader(url){
        let isTransparentHeader = false;
        if(url && (url.indexOf("logout") !== -1 || url.indexOf("circles") !== -1 || url.indexOf("dashboard") !== -1 || url.indexOf("help") !== -1)){
            return false;
        }
        const profileMatch = matchPath(url, {
            path: "/profile",
            exact: true
        });
        if(profileMatch !== null){
            isTransparentHeader = true;
        }

        const searchMatch = matchPath(url, {
            path: "/:username",
            exact: true
        });
        if(searchMatch !== null){
            isTransparentHeader = true;
        }
        const featuredMatch = matchPath(url, {
            path: "/:username/featured",
            exact: true
        });
        if(featuredMatch !== null){
            isTransparentHeader = true;
        }
        const aboutMatch = matchPath(url, {
            path: "/:username/about",
            exact: true
        });
        if(aboutMatch !== null){
            isTransparentHeader = true;
        }
        return isTransparentHeader;
    },
    getBodyClass(url){
        let bodyClass = "layout_page"+url.replace(/\//g,"_");
        if(bodyClass === "layout_page_" || bodyClass === "layout_page"){
            bodyClass = "layout_page_home";
        }
        if(url && (url.indexOf("login") !== -1 || url.indexOf("signup") !== -1 || url.indexOf("logout") !== -1 || 
        url.indexOf("circles") !== -1 || url.indexOf("dashboard") !== -1 || url.indexOf("help") !== -1)){
            return bodyClass;
        }
        if(url && (url.indexOf("shared/view") !== -1)){
            bodyClass = "layout_page_shared_view";
        }
        bodyClass = bodyClass.replace(/-/g,"_");
        return bodyClass;
    },
    fc(a){
        return a * Math.PI / 180;
    },
    gc(a){
        return 180 * a / Math.PI;
    },
    ud(a){
        return this.fc(a.lat())
    },
    vd(a) {
        return this.fc(a.lng())
    },
    computeOffset(a, b, c, d){
        b /= d || 6378137;
        c = this.fc(c);
        var e = this.ud(a);
        a = this.vd(a);
        d = Math.cos(b);
        b = Math.sin(b);
        var f = Math.sin(e);
        e = Math.cos(e);
        var g = d * f + b * e * Math.cos(c);
        return new window.google.maps.LatLng(this.gc(Math.asin(g)), this.gc(a + Math.atan2(b * e * Math.sin(c), d - f * g)));
    },
    detectMobile: function(){
        if(this.isMobile !== null){
            return this.isMobile;
        }
        const mobileAgents = ["iphone", "ipod","ipad", "macintosh", "android","googletv", "nuvifone", "symbian","series60",
            "series70", "series80","series90", "windows phone os 7", "windows phone os 8", "windows ce","iemobile", "ppc","wm5 pie", "blackberry",
            "vnd.rim","blackberry95", "blackberry97", "blackberry96","blackberry89", "blackberry 98", "palm","webos", "blazer", "xiino",
            "kindle", "vnd.wap", "wml","brew", "danger", "hiptop","playstation","nitro", "nintendo", "wii","xbox","archos",
            "netfront","up.browser", "openweb", "midp","up.link", "teleca q", "pda","mini","mobile", "mobi", "maemo","tablet",
            "qt embedded","com2", "sonyericsson", "ericsson","sec-sgh", "sony", "htc","docomo", "kddi", "vodafone","update"];
        const uagent = navigator.userAgent.toLowerCase();
        const self = this;
        self.isMobile = false;
        mobileAgents.forEach(function(agent,key){
            if (uagent.search(agent) > -1){
                self.isMobile = true;
                return true;
            }
        });
        return self.isMobile;
    },
    isIOS(){
        const mobileAgents = ["iphone", "ipod","ipad", "macintosh"];
        const uagent = navigator.userAgent.toLowerCase();
        let iOS = false;
        mobileAgents.map((agent) => {
            if (uagent.search(agent) > -1){
                iOS = true;
                return true;
            }
            return null;
        });
        return iOS;
    },
    checkElementInViewPort(selector){
        try{
            if(!selector){
                selector = ".sd_track_view:not(.sd_view_tracked)";
            }
        }catch(e){ }
        
        try{
            if($(selector).length <= 0){
                return;
            }
            const that = this;
            
            var requestData = [];
            $(selector).forEach(function(card){
                if(that.isElementInViewport(card)){
                    var tracked = parseInt(card.getAttribute("data-tracked"));
                    if(!tracked){
                        card.setAttribute("data-tracked",1);
                        card.className += " sd_view_tracked";
                        requestData.push({
                            'activityType': "content_viewed",
                            'contentId': card.getAttribute("data-id")
                        });
                    }
                }
            });
            if(requestData.length > 0){
                Api.sendActivity(requestData);
            }
        }catch(e){ console.log(e); }
    },
    isElementInViewport: function(el) {
        var rect = el.getBoundingClientRect();
        if(this.detectMobile()){
            return (
                rect.left >= 0 &&
                (rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) && /*or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            );
        }else{
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                (rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) && /*or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            );
        }
    },
    isUsernameMatchingRoute(username){
        if(username === "profile" || username === "login" || username === "signup" || username === "logout" || username === "logout"
        || username === "circles" || username === "dashboard" || username === "help"){
            return true;
        }
        return false;
    },
    getFormatedSize(size){
        if(size <= 0){
            return "0 KB";
        }
        const KB = size/1024;
        if(KB < 1024){
            return (Math.round( KB * 10 ) / 10)+" KB";
        }

        const MB = KB/1024;
        if(MB < 1024){
            return (Math.round( MB * 100 ) / 100)+" MB";
        }

        const GB = MB/1024;
        return (Math.round( GB * 100 ) / 100)+" GB";
    },
    getBytesSize(size){
        let sizeSplit = size.split(" ");
        let totalSize = sizeSplit[0];
        let sizeType = sizeSplit[1];

        if(sizeType === "KB"){
            return totalSize*1024;
        }else if(sizeType === "MB"){
            return totalSize*1048576;
        }else if(sizeType === "GB"){
            return totalSize*1073741824;
        }
    },
    isDocumentEditPage(url){
        if(!url || url.length <= 0){
            return false;
        }
        if(url.indexOf("document/edit") === -1 && url.indexOf("document/editnew") === -1){
            return false;
        }
        return true;
    },
    isOfficeDocument(file){
        if(!file || typeof(file.extension) !== "string"){
            return false;
        }
        let officeDocument = false;
        let extension = file.extension.toLowerCase();
        switch(extension){
            case 'csv':
            case 'ods':
            case 'xls':
            case 'xlsb':
            case 'xlsm':
            case 'xlsx':
            case 'one':
            case 'onetoc2':
            case 'onepkg':
            case 'odp':
            case 'pot':
            case 'potm':
            case 'potx':
            case 'pps':
            case 'ppsm':
            case 'ppsx':
            case 'ppt':
            case 'pptm':
            case 'pptx':
            case 'vdw':
            case 'vsd':
            case 'vsdm':
            case 'vsdx':
            case 'wopitest':
            case 'wopitestx':
            case 'doc':
            case 'docm':
            case 'docx':
            case 'dot':
            case 'dotm':
            case 'dotx':
            case 'odt':
            case 'rtf':
            case 'b':
            case 'fluid':
            case 'note':
            case 'whiteboard':
                officeDocument = true;
                break;
            default:
                break;
        }
        return officeDocument;
    },
    canEditDocument(file){
        if(!file || typeof(file.extension) !== "string"){
            return false;
        }
        let canEdit = false;
        let extension = file.extension.toLowerCase();
        switch(extension){
            case 'xlsx':
            case 'xlsb':
            case 'xlsm':
            case 'pptx':
            case 'ppsx':
            case 'docx':
            case 'docm':
                canEdit = true;
                break;
            default:
                break;
        }
        return canEdit;
    },
    canSignDocument(file){
        if(!file || typeof(file.extension) !== "string"){
            return false;
        }
        let signDocument = false;
        let extension = file.extension.toLowerCase();
        switch(extension){
            case 'csv':
            case 'ods':
            case 'xls':
            case 'xlsb':
            case 'xlsm':
            case 'xlsx':
            case 'one':
            case 'onetoc2':
            case 'onepkg':
            case 'odp':
            case 'pot':
            case 'potm':
            case 'potx':
            case 'pps':
            case 'ppsm':
            case 'ppsx':
            case 'ppt':
            case 'pptm':
            case 'pptx':
            case 'vdw':
            case 'vsd':
            case 'vsdm':
            case 'vsdx':
            case 'wopitest':
            case 'wopitestx':
            case 'doc':
            case 'docm':
            case 'docx':
            case 'dot':
            case 'dotm':
            case 'dotx':
            case 'odt':
            case 'rtf':
            case 'b':
            case 'fluid':
            case 'note':
            case 'whiteboard':
            case 'pdf':
                signDocument = true;
                break;
            default:
                break;
        }
        return signDocument;
    },
    hasThumbnail(file){
        if(!file || typeof(file.extension) !== "string"){
            return false;
        }
        let hasThumbnail = false;
        let extension = file.extension.toLowerCase();        
        switch(extension){
            case 'png':
            case 'jpg':
            case 'jpeg':
                hasThumbnail = true;
                break;
            default:
                break;
        }
        if(hasThumbnail === true && file.hasOwnProperty("thumbnails") && Object.keys(file.thumbnails).length > 0){
            hasThumbnail = true;
            return hasThumbnail;
        }

        return false;
    },
    getImageIcon(file, classes, modificationAllowed, grid){
        if(modificationAllowed === false){
            return "";
        }

        let icon = <Button justIcon color="transparent" className={classes.fileIcon}>
            <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM2.5 10C2.5 9.66848 2.6317 9.35054 2.86612 9.11612C3.10054 8.8817 3.41848 8.75 3.75 8.75C4.08152 8.75 4.39946 8.8817 4.63388 9.11612C4.8683 9.35054 5 9.66848 5 10C5 10.3315 4.8683 10.6495 4.63388 10.8839C4.39946 11.1183 4.08152 11.25 3.75 11.25C3.41848 11.25 3.10054 11.1183 2.86612 10.8839C2.6317 10.6495 2.5 10.3315 2.5 10ZM8.4375 11.25C8.64453 11.25 8.83594 11.3516 8.95312 11.5195L12.3906 16.5195C12.5234 16.7109 12.5352 16.9609 12.4297 17.1641C12.3242 17.3672 12.1094 17.5 11.875 17.5H8.4375H6.875H5H3.125C2.89844 17.5 2.69141 17.3789 2.58203 17.1836C2.47266 16.9883 2.47266 16.7461 2.58984 16.5547L4.46484 13.4297C4.57812 13.2422 4.78125 13.125 5 13.125C5.21875 13.125 5.42188 13.2383 5.53516 13.4297L6.03516 14.2656L7.92188 11.5234C8.03906 11.3555 8.23047 11.2539 8.4375 11.2539V11.25Z" fill="#D11A2A"/>
            </svg>
        </Button>

        if(file.hasOwnProperty("thumbnails") && Object.keys(file.thumbnails).length > 0){
            icon = <Button justIcon color="transparent" className={classes.fileIcon}>
                    <img className='thumbnail' src={grid === true ? file.thumbnails.medium : file.thumbnails.small} alt="thumbnail"/>
                </Button>
        }

        return icon;
    },
    getPdfIcon(file, classes){
        let icon = <Button justIcon color="transparent" className={classes.fileIcon}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 2.5C0 1.12109 1.15726 0 2.58065 0H9.03226V5C9.03226 5.69141 9.60887 6.25 10.3226 6.25H15.4839V11.875H7.09677C5.67339 11.875 4.51613 12.9961 4.51613 14.375V20H2.58065C1.15726 20 0 18.8789 0 17.5V2.5ZM15.4839 5H10.3226V0L15.4839 5ZM7.09677 13.75H8.3871C9.63306 13.75 10.6452 14.7305 10.6452 15.9375C10.6452 17.1445 9.63306 18.125 8.3871 18.125H7.74194V19.375C7.74194 19.7188 7.45161 20 7.09677 20C6.74194 20 6.45161 19.7188 6.45161 19.375V17.5V14.375C6.45161 14.0312 6.74194 13.75 7.09677 13.75ZM8.3871 16.875C8.92339 16.875 9.35484 16.457 9.35484 15.9375C9.35484 15.418 8.92339 15 8.3871 15H7.74194V16.875H8.3871ZM12.2581 13.75H13.5484C14.6169 13.75 15.4839 14.5898 15.4839 15.625V18.125C15.4839 19.1602 14.6169 20 13.5484 20H12.2581C11.9032 20 11.6129 19.7188 11.6129 19.375V14.375C11.6129 14.0312 11.9032 13.75 12.2581 13.75ZM13.5484 18.75C13.9032 18.75 14.1935 18.4688 14.1935 18.125V15.625C14.1935 15.2812 13.9032 15 13.5484 15H12.9032V18.75H13.5484ZM16.7742 14.375C16.7742 14.0312 17.0645 13.75 17.4194 13.75H19.3548C19.7097 13.75 20 14.0312 20 14.375C20 14.7188 19.7097 15 19.3548 15H18.0645V16.25H19.3548C19.7097 16.25 20 16.5312 20 16.875C20 17.2188 19.7097 17.5 19.3548 17.5H18.0645V19.375C18.0645 19.7188 17.7742 20 17.4194 20C17.0645 20 16.7742 19.7188 16.7742 19.375V16.875V14.375Z" fill="#D11A2A"/>
            </svg>
        </Button>

        // if(file.hasOwnProperty("signed") && file.signed === 1){
        //     icon = <Button justIcon color="transparent" className={classes.fileIcon}>
        //         <img src={pdfSigndIcon} alt={"folder"} />
        //     </Button>
        // }

        return icon;
    },
    getFileExtension(filename){
        const parts = filename.split('.');
        return parts[parts.length - 1];
    },
    getFileIcon(file, classes, modificationAllowed = false, grid = false){
        if(!file){
            return false;
        }
        let icon = false;
        let extension = '';
        if(file.hasOwnProperty('extension')){
            extension = file.extension.toLowerCase();
        }else if(file.name){
            extension = this.getFileExtension(file.name);
        }
        if(extension === ""){
            return false;
        }
        switch(extension){
            case 'pdf':
                icon = this.getPdfIcon(file, classes);
                break;
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'bmp':
            case 'tiff':
            case 'svg':
                icon = this.getImageIcon(file, classes, modificationAllowed, grid)
                break;
            case 'mp3':
            case 'mpeg':
            case 'wav':
            case 'ogg':
            case 'opus':
                icon = <Button justIcon color="transparent" className={classes.fileIcon}>
                    <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM11.25 8.75V10V15C11.25 15.6914 10.4102 16.25 9.375 16.25C8.33984 16.25 7.5 15.6914 7.5 15C7.5 14.3086 8.33984 13.75 9.375 13.75C9.59375 13.75 9.80469 13.7734 10 13.8203V10.9023L6.25 12.3086V16.25C6.25 16.9414 5.41016 17.5 4.375 17.5C3.33984 17.5 2.5 16.9414 2.5 16.25C2.5 15.5586 3.33984 15 4.375 15C4.59375 15 4.80469 15.0234 5 15.0703V11.875V10.625C5 10.3633 5.16016 10.1328 5.40625 10.0391L10.4062 8.16406C10.5977 8.09375 10.8125 8.11719 10.9805 8.23438C11.1484 8.35156 11.25 8.54297 11.25 8.75Z" fill="#D11A2A"/>
                    </svg>
                </Button>
                break;
            case 'webm':
            case 'mpeg4':
            case '3gpp':
            case 'mov':
            case 'avi':
            case 'mpegps':
            case 'wmv':
            case 'flv':
                icon = <Button justIcon color="transparent" className={classes.fileIcon}>
                    <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM2.5 11.25C2.5 10.5586 3.05859 10 3.75 10H7.5C8.19141 10 8.75 10.5586 8.75 11.25V15C8.75 15.6914 8.19141 16.25 7.5 16.25H3.75C3.05859 16.25 2.5 15.6914 2.5 15V11.25ZM11.7539 15.543L10 14.375V11.875L11.7539 10.707C11.832 10.6562 11.9258 10.625 12.0195 10.625C12.2852 10.625 12.5 10.8398 12.5 11.1055V15.1445C12.5 15.4102 12.2852 15.625 12.0195 15.625C11.9258 15.625 11.832 15.5977 11.7539 15.543Z" fill="#D11A2A"/>
                    </svg>
                </Button>
                break;
            case 'doc':
            case 'docm':
            case 'docx':
            case 'dot':
            case 'dotm':
            case 'dotx':
            case 'odt':
            case 'rtf':
                icon = <Button justIcon color="transparent" className={classes.fileIcon}>
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <rect width="25" height="25" fill="url(#pattern0_369_86)"/>
                    <defs>
                    <pattern id="pattern0_369_86" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_369_86" transform="scale(0.00666667)"/>
                    </pattern>
                    <image id="image0_369_86" width="150" height="150" xlinkHref="data:image/png;base64,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"/>
                    </defs>
                    </svg>
                </Button>
                break;
            case 'odp':
            case 'pot':
            case 'potm':
            case 'potx':
            case 'pps':
            case 'ppsm':
            case 'ppsx':
            case 'ppt':
            case 'pptm':
            case 'pptx':
                icon = <Button justIcon color="transparent" className={classes.fileIcon}>
                    <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <rect width="25" height="21" fill="url(#pattern0_369_87)"/>
                    <defs>
                    <pattern id="pattern0_369_87" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_369_87" transform="matrix(0.00666667 0 0 0.00793651 0 -0.0952381)"/>
                    </pattern>
                    <image id="image0_369_87" width="150" height="150" xlinkHref="data:image/png;base64,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"/>
                    </defs>
                    </svg>
                </Button>
                break;
            case 'csv':
            case 'ods':
            case 'xls':
            case 'xlsb':
            case 'xlsm':
            case 'xlsx':
                icon = <Button justIcon color="transparent" className={classes.fileIcon}>
                    <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <rect width="25" height="22.8261" fill="url(#pattern0_369_88)"/>
                    <defs>
                    <pattern id="pattern0_369_88" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_369_88" transform="matrix(0.00666667 0 0 0.00730159 0 -0.0476191)"/>
                    </pattern>
                    <image id="image0_369_88" width="150" height="150" xlinkHref="data:image/png;base64,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"/>
                    </defs>
                    </svg>
                </Button>
                break;
            case 'zip':
            case 'rar':
            case 'tar':
            case 'gzip':
                icon = <Button justIcon color="transparent" className={classes.fileIcon}>
                    <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM3.75 1.875C3.75 1.53125 4.03125 1.25 4.375 1.25H5.625C5.96875 1.25 6.25 1.53125 6.25 1.875C6.25 2.21875 5.96875 2.5 5.625 2.5H4.375C4.03125 2.5 3.75 2.21875 3.75 1.875ZM3.75 4.375C3.75 4.03125 4.03125 3.75 4.375 3.75H5.625C5.96875 3.75 6.25 4.03125 6.25 4.375C6.25 4.71875 5.96875 5 5.625 5H4.375C4.03125 5 3.75 4.71875 3.75 4.375ZM3.75 6.875C3.75 6.53125 4.03125 6.25 4.375 6.25H5.625C5.96875 6.25 6.25 6.53125 6.25 6.875C6.25 7.21875 5.96875 7.5 5.625 7.5H4.375C4.03125 7.5 3.75 7.21875 3.75 6.875ZM3.50391 9.67969C3.64844 9.13281 4.14453 8.75 4.71094 8.75H5.28906C5.85547 8.75 6.35156 9.12891 6.49609 9.67969L7.41406 13.125C7.46875 13.3359 7.49609 13.5508 7.49609 13.7656C7.49609 15.1406 6.37109 16.2539 4.99609 16.2539C3.62109 16.2539 2.49609 15.1406 2.49609 13.7656C2.49609 13.5508 2.52344 13.332 2.57812 13.125L3.49609 9.67969H3.50391ZM4.375 13.125C4.03125 13.125 3.75 13.4062 3.75 13.75C3.75 14.0938 4.03125 14.375 4.375 14.375H5.625C5.96875 14.375 6.25 14.0938 6.25 13.75C6.25 13.4062 5.96875 13.125 5.625 13.125H4.375Z"/>
                    </svg>
                </Button>
                break;
            case 'one':
            case 'onetoc2':
            case 'onepkg':
            case 'vdw':
            case 'vsd':
            case 'vsdm':
            case 'vsdx':
            case 'txt':
            case 'wopitest':
            case 'wopitestx':
            case 'b':
            case 'fluid':
            case 'note':
            case 'whiteboard':
            default:
                icon =  <Button justIcon color="transparent" className={classes.fileIcon}>
                    <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM4.375 10H10.625C10.9688 10 11.25 10.2812 11.25 10.625C11.25 10.9688 10.9688 11.25 10.625 11.25H4.375C4.03125 11.25 3.75 10.9688 3.75 10.625C3.75 10.2812 4.03125 10 4.375 10ZM4.375 12.5H10.625C10.9688 12.5 11.25 12.7812 11.25 13.125C11.25 13.4688 10.9688 13.75 10.625 13.75H4.375C4.03125 13.75 3.75 13.4688 3.75 13.125C3.75 12.7812 4.03125 12.5 4.375 12.5ZM4.375 15H10.625C10.9688 15 11.25 15.2812 11.25 15.625C11.25 15.9688 10.9688 16.25 10.625 16.25H4.375C4.03125 16.25 3.75 15.9688 3.75 15.625C3.75 15.2812 4.03125 15 4.375 15Z" fill="#0078D4"/>
                    </svg>
                </Button>;
                break;
        }
        return icon;
    },
    isPdfDocument(file){
        if(!file || typeof(file.extension) !== "string"){
            return false;
        }
        let pdfDocument = false;
        let extension = file.extension.toLowerCase();
        switch(extension){
            case 'pdf':
                pdfDocument = true;
                break;
            default:
                break;
        }
        return pdfDocument;
    },
    isFloat(n){
        return Number(n) === n && n % 1 !== 0;
    },
    getHomePageUrl(user){
        let url = '/user/send';
        if(user.hasOwnProperty('home_page')){
            switch(user.home_page){
                case 'send_mail' :
                    url = '/user/send';
                    break;
                case 'my_docs' :
                    url = '/user/home?dir=/My Docs';
                    break;
                case 'link_manager' :
                    url = '/user/links';
                    break;
                case 'external_links' :
                    url = '/user/external-links';
                    break;
                case 'shared' :
                    url = '/user/shared';
                    break;
                default:
                    url = '/user/send';
                    break;
            }
        }
        return url;
    },
    showSidebar(url, user, authorized){    
        if(url === '/auth/login' || !authorized){
            return false;
        }    
        
        if(url === '/user/archives' || url === '/user/archives-transfers' || url === '/user/downloads' 
            || url === '/user/external-links' || url === '/user/favourites' || url === '/user/links' 
            || url === '/user/send' || url === '/user/settings' || url === '/user/support' || url === '/user/tutorials'
            || url.indexOf("/user/home") !== -1 || url.indexOf("/user/files") !== -1 || url.indexOf("/user/shared") !== -1 
            || url.indexOf("/user/trash") !== -1
            || url === '/attachment/rules' || url === '/videos' || url === '/users'
            || url === '/user/account' || url === '/user/ad-management' || url === '/user/billinghistory'
            || url === '/user/business' || url === '/user/download' || url === '/user/export' || url === '/user/history'
            || url === '/user/password' || url === '/user/privacy' || url === '/user/profile' || url === '/user/security' 
            || url === '/user/account/recovery' || url === '/user/referrals' || url.indexOf("/user/accounts") !== -1 
            || url.indexOf("/user/extensions") !== -1 || (url.indexOf("/plans") !== -1 && user.account_type !== -1)
            || url.indexOf("/user/pdf/analytics") !== -1 || url.indexOf("/agreement/policy") !== -1 
            || url.indexOf("/user/textract") !== -1){
            return true;
        }

        return false;
    },
    showBusinessSidebar(url){
        if(url === '/attachment/rules' || url === '/videos' || url === '/users'){
            return true;
        }

        return false;
    },
    showAccountSidebar(url, user){
        if(url === '/user/account' || url === '/user/ad-management' || url === '/user/billinghistory'
            || url === '/user/business' || url === '/user/download' || url === '/user/export' || url === '/user/history'
            || url === '/user/password' || url === '/user/privacy' || url === '/user/profile' || url === '/user/referrals'
            || url === '/user/security' || url === '/user/account/recovery' || url.indexOf("/user/accounts") !== -1 
            || url.indexOf("/user/extensions") !== -1 || (url.indexOf("/plans") !== -1 && user.account_type !== -1)){
            return true;
        }

        return false;
    },
    isMenuActive(name, url){
        let path = this.getPath();
        
        if(name === 'send'){
            if(url === '/user/send'){
                return true;
            }
        }else if(name === 'email'){
            if(path === '/Email'){
                return true;
            }
        }else if(name === 'email_web'){
            if(path.indexOf('/Email/Web') !== -1){
                return true;
            }
        }else if(name === 'email_outlook'){
            if(path.indexOf('/Email/Outlook') !== -1){
                return true;
            }
        }else if(name === 'mydocs'){
            if(path.indexOf('/My Docs') !== -1 || path.indexOf('/OneDrive') !== -1 || path.indexOf('/Sharepoint') !== -1){
                return true;
            }
        }else if(name === 'archives'){
            if(url === '/user/archives-transfers'){
                return true;
            }
        }else if(name === 'trash'){
            if(url === '/user/trash'){
                return true;
            }
        }else if(name === 'trash_files'){
            if(url === '/user/trash/files'){
                return true;
            }
        }else if(name === 'trash_links'){
            if(url === '/user/trash/links'){
                return true;
            }
        }else if(name === 'quick'){
            if(url === '/user/favourites'){
                return true;
            }
        }else if(name === 'link_manager'){
            if(url === '/user/links'){
                return true;
            }
        }else if(name === 'external_links'){
            if(url === '/user/external-links'){
                return true;
            }
        }else if(name === 'shared'){
            if(url === '/user/shared'){
                return true;
            }
        }else if(name === 'settings'){
            if(url === '/user/settings'){
                return true;
            }
        }else if(name === 'admin'){
            if(url === '/users'){
                return true;
            }
        }else if(name === 'attachment_rules'){
            if(url === '/attachment/rules'){
                return true;
            }
        }else if(name === 'videos'){
            if(url === '/videos'){
                return true;
            }
        }else if(name === 'profile'){
            if(url === '/user/profile'){
                return true;
            }
        }else if(name === 'business_profile'){
            if(url === '/user/business'){
                return true;
            }
        }else if(name === 'ad_management'){
            if(url === '/user/ad-management'){
                return true;
            }
        }else if(name === 'password'){
            if(url === '/user/password'){
                return true;
            }
        }else if(name === 'connected_account'){
            if(url === '/user/accounts/license'){
                return true;
            }
        }else if(name === 'privacy'){
            if(url === '/user/privacy'){
                return true;
            }
        }else if(name === 'export'){
            if(url === '/user/export'){
                return true;
            }
        }else if(name === 'download'){
            if(url === '/user/download'){
                return true;
            }
        }else if(name === 'history'){
            if(url === '/user/history'){
                return true;
            }
        }else if(name === 'extensions'){
            if(url === '/user/extensions'){
                return true;
            }
        }else if(name === 'billing'){
            if(url === '/user/account'){
                return true;
            }
        }else if(name === 'plans'){
            if(url === '/user/plans'){
                return true;
            }
        }else if(name === 'refer_friend'){
            if(url === '/user/referrals'){
                return true;
            }
        }else if(name === 'security'){
            if(url === '/user/security' || url === '/user/accounts/license' || url === '/user/password' || url === '/user/account/recovery'){
                return true;
            }
        }else if(name === 'pdf_analytics'){
            if(url === '/user/pdf/analytics'){
                return true;
            }
        }else if(name === 'textract'){
            if(url === '/user/textract' || url === '/user/textract/balance'){
                return true;
            }
        }else if(name === 'textract_results'){
            if(url === '/user/textract/results'){
                return true;
            }
        }else if(name === 'textract_projects'){
            if(url === '/user/textract/projects'){
                return true;
            }
        }

        return false;
    },
    getPath(){
        let path = this.getParam("dir");
        if(path === null || path === "null"){
            path = "/";
        }

        return path;
    },
    getFolderIcon(shared = false){
        if(shared){
            return (
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_552_129)">
                <path opacity="0.4" d="M2.76293 20.7167H19.2629C20.7797 20.7167 22.0129 19.4835 22.0129 17.9667V6.96667C22.0129 5.40834 22.4297 3.75834 20.9129 3.75834H16.1463C15.4129 3.75834 11.9296 3.94167 11.3796 3.57501L10.4629 2.65834C9.7296 2.01667 9.49327 1.55834 8.6296 1.55834L1.29627 1.46667C-0.220529 1.46667 0.0129346 2.69988 0.0129346 4.21667V17.9667C0.0129346 19.4835 1.24614 20.7167 2.76293 20.7167Z" fill="#FAAF42"/>
                <g clipPath="url(#clip1_552_129)">
                <path d="M6.65 9.25C6.65 8.65326 6.88179 8.08097 7.29436 7.65901C7.70694 7.23705 8.26652 7 8.85 7C9.43348 7 9.99306 7.23705 10.4056 7.65901C10.8182 8.08097 11.05 8.65326 11.05 9.25C11.05 9.84674 10.8182 10.419 10.4056 10.841C9.99306 11.2629 9.43348 11.5 8.85 11.5C8.26652 11.5 7.70694 11.2629 7.29436 10.841C6.88179 10.419 6.65 9.84674 6.65 9.25ZM11.6 12.3438L12.7 16H5L6.1 12.3438H11.6ZM16 16H13.2758L13.2259 15.8348L12.26 12.625H14.9L16 16ZM12.425 11.5C11.8922 11.5 11.4109 11.2785 11.062 10.9217C11.4006 10.4541 11.6 9.87578 11.6 9.25C11.6 8.77891 11.4866 8.33418 11.2855 7.94395C11.6052 7.70488 11.9988 7.5625 12.425 7.5625C13.4889 7.5625 14.35 8.44316 14.35 9.53125C14.35 10.6193 13.4889 11.5 12.425 11.5Z" fill="#FAAF42"/>
                </g>
                </g>
                <defs>
                <clipPath id="clip0_552_129">
                <rect width="22" height="22" fill="white"/>
                </clipPath>
                <clipPath id="clip1_552_129">
                <rect width="11" height="9" fill="white" transform="translate(5 7)"/>
                </clipPath>
                </defs>
                </svg> 
            )
        }
        return (
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_552_53)">
            <path d="M0.0267859 6.96667H21.9732V5.8668C21.9732 4.65351 22.2861 3.66706 20.773 3.66706H12.3716C11.9387 3.66706 11.6001 3.72549 11.3429 3.44709L9.7998 1.98059C9.28115 1.42722 9.11826 1.46732 8.2567 1.46732L1.22699 1.46732C-0.286117 1.46732 0.0267859 2.45376 0.0267859 3.66706V6.96667Z" fill="#FAAF42"/>
            <path opacity="0.6" d="M0 6.96667V17.5185C0 19.1814 1.2332 20.5333 2.75 20.5333H19.25C20.7668 20.5333 22 19.1814 22 17.5185V6.96667H0Z" fill="#FAAF42"/>
            </g>
            <defs>
            <clipPath id="clip0_552_53">
            <rect width="22" height="22" fill="white"/>
            </clipPath>
            </defs>
            </svg> 
        )
    },
    isExtensionAllowed(user, type = '', returnData = false){
        if(!user.hasOwnProperty('adminExtensions') || type === ''){
            return;
        }

        let extension = user.adminExtensions.find((item) => item.extension === type);
        if(!extension){
            return;
        }

        if(returnData){
            return extension;
        }

        if(extension.status){
            return true;
        }
        return false;
    },
    isExtensionEnable(user, type = ''){
        if(type === ''){
            return false;
        }

        if(!user.extensions.hasOwnProperty(type)){
            return false;
        }

        return user.extensions[type].status;
    },
    getExtensionsData(user, type = '', dataType = ''){
        if(type === '' || dataType === ''){
            return;
        }

        let extensionData = this.isExtensionAllowed(user, type, true);
        if(dataType === 'extension'){
            return this.getExtensionType(extensionData[dataType]);
        }
        return extensionData[dataType];
    },
    getExtensionType(extension){
        let type = "";
        this.getExtensions().map((item) => {
            if(item.id === extension){
                type = item.label;
            }
            return null;
        });

        return type;
    },
    getExtensions(){
        let extensions = [
            {
                id: "adobesign",
                label: "Adobesign",
            },
            {
                id: "docusign",
                label: "Docusign",
            },
            {
                id: "ms_office",
                label: "Microsoft Office 365 Online(Word, Excel, PowerPoint)",
            },
            {
                id: "one_drive",
                label: "Microsoft OneDrive",
            },
            {
                id: "sharepoint",
                label: "Microsoft SharePoint",
            },
            {
                id: "google_drive",
                label: "Google Drive",
            },
            {
                id: "have_i_been_pwned",
                label: "Security Check (Have I been Pwned)",
            },
            {
                id: "pdf_track",
                label: "PDF Track",
            },
            {
                id: "textify",
                label: "Textify",
            },
            {
                id: "file_attachment_rules",
                label: "File Attachment Rules (FAR)",
            },
        ];

        return extensions;
    },
    getExtensionPath(user, type = ''){
        let path = "/My Docs"
        if(type === ''){
            return path;
        }

        if(user.extensions[type].path !== null){
            path += "/"+user.extensions[type].path;
        }

        return path;
    },
    /**
     * Share permission model.
     * Levels (in order of increasing breadth of access):
     *   view     - can view the file/folder listing only
     *   read     - "Preview": listing + open/preview files (docs, images, PDFs)
     *   download - listing + preview + download
     *   upload   - listing + preview + upload (NOT download, NOT manage)
     *   write    - "Full": listing + preview + download + upload + manage
     * Note: upload/download are intentionally NOT a strict superset chain
     * (an upload user can preview but not download), so each capability is
     * checked independently rather than by a single numeric rank.
     * `isOwner` short-circuits to full access for the resource owner.
     * A null/empty/unknown privacy grants nothing (except to the owner).
     */
    normalizeSharePrivacy(privacy){
        if(privacy === undefined || privacy === null){
            return "";
        }
        return (""+privacy).toLowerCase().trim();
    },
    canViewSharedListing(privacy, isOwner = false){
        if(isOwner === true){ return true; }
        return ["view", "read", "download", "upload", "write"].indexOf(this.normalizeSharePrivacy(privacy)) !== -1;
    },
    canPreviewSharedFiles(privacy, isOwner = false){
        if(isOwner === true){ return true; }
        return ["read", "download", "upload", "write"].indexOf(this.normalizeSharePrivacy(privacy)) !== -1;
    },
    canDownloadSharedFiles(privacy, isOwner = false){
        if(isOwner === true){ return true; }
        return ["download", "write"].indexOf(this.normalizeSharePrivacy(privacy)) !== -1;
    },
    canUploadSharedFiles(privacy, isOwner = false){
        if(isOwner === true){ return true; }
        return ["upload", "write"].indexOf(this.normalizeSharePrivacy(privacy)) !== -1;
    },
    canManageSharedFiles(privacy, isOwner = false){
        if(isOwner === true){ return true; }
        return this.normalizeSharePrivacy(privacy) === "write";
    },
    getSharePrivacyLabel(privacy){
        switch(this.normalizeSharePrivacy(privacy)){
            case "view": return "View Only";
            case "read": return "Preview Only";
            case "download": return "Download";
            case "upload": return "Uploads Allowed";
            case "write": return "Full Access";
            default: return "";
        }
    }
}

export { helper };